import { gql } from '@apollo/client';

export const UPDATE_PASSWORD = gql`
  mutation UpdatePassword($payload: changePasswordByAdminIn) {
    changePasswordByAdmin(input: $payload) {
      status
    }
  }
`;
export const GET_SCRIPT_DETAILS = gql`
  query {
    getRunScriptCouseIncomeStudents {
      title
      status
      link
      pdfLink
    }
  }
`;
export const GET_CURRIER_SCRIPT_DETAILS = gql`
  query {
    getRunScriptCurrierReport {
      title
      status
      link
      key
      pdfLink
      start
      end
      created_at
    }
  }
`;

export const SEARCH_ADMINS = gql`
  query searchAdminAccounts($filters: AccountSearchIn) {
    searchAdminAccounts(input: $filters) {
      limit
      skip
      resultCount
      result {
        _id
        fname
        lname
        email
        role
        actions
        status
        created_at
        updated_at
      }
    }
  }
`;

export const GET_ADMIN_ACCOUNT = gql`
  query getAdminAccount($accountId: String!) {
    getAdminAccount(accountId: $accountId) {
      account {
        _id
        fname
        lname
        email
        status
        role
        actions
        otp_enabled
        created_at
        updated_at
      }
    }
  }
`;

export const GET_ROLES_AND_ACCOUNT_ACTIONS = gql`
  query getRolesAndAccountActions {
    getRolesAndAccountActions {
      roles
      actions {
        group
        actions {
          action
          label
          roles
        }
      }
    }
  }
`;

export const CREATE_ADMIN_ACCOUNT = gql`
  mutation CreateAdminAccount($input: AdminAccountIn) {
    createAdminAccount(input: $input) {
      status
    }
  }
`;
export const UPDATE_ADMIN_ACCOUNT = gql`
  mutation UpdateAdminAccount($input: AdminAccountIn) {
    updateAdminAccount(input: $input) {
      status
    }
  }
`;

export const SEND_OTP = gql`
  mutation SendOtp($input: createStudentOTpSendIn) {
    createStudentOTpSend(input: $input) {
      status
    }
  }
`;

export const VERIFY_OTP = gql`
  mutation VerifyOtp($input: createStudentOTpVerifyIn) {
    createStudentOTpVerify(input: $input) {
      mobileVerifedToken
    }
  }
`;
export const GET_ADMIN_PAYMENT_DETAILS = gql`
  query {
    getRunScriptAdminPayments {
      title
      status
      link
    }
  }
`;

export const SEND_ADMIN_OTP = gql`
  mutation SendAdminOtp {
    sendAdminOtp {
      status
      maskedMobile
    }
  }
`;

export const SETUP_ADMIN_OTP = gql`
  mutation SetupAdminOtp($mobile: String!) {
    setupAdminOtp(mobile: $mobile) {
      status
      backupCodes
      maskedMobile
    }
  }
`;

export const VERIFY_ADMIN_OTP = gql`
  mutation VerifyAdminOtp($code: String!) {
    verifyAdminOtp(code: $code) {
      success
    }
  }
`;
export const VERIFY_ADMIN_BACKUP_CODE = gql`
  mutation VerifyAdminBackupCode($backupCode: String!) {
    verifyAdminBackupCode(backupCode: $backupCode) {
      success
      remainingBackupCodes
    }
  }
`;
export const ISSUE_ADMIN_OTP_BYPASS = gql`
  mutation IssueAdminOtpBypass($targetAccountId: String!, $expiresInMinutes: Int) {
    issueAdminOtpBypass(targetAccountId: $targetAccountId, expiresInMinutes: $expiresInMinutes) {
      bypassToken
      expiresAt
      expiresInMinutes
    }
  }
`;

export const REVOKE_ADMIN_OTP_BYPASS = gql`
  mutation RevokeAdminOtpBypass($targetAccountId: String!, $bypassToken: String!) {
    revokeAdminOtpBypass(targetAccountId: $targetAccountId, bypassToken: $bypassToken) {
      success
    }
  }
`;

export const GET_BYPASS_TOKEN_STATUS = gql`
  mutation GetBypassTokenStatus($targetAccountId: String!, $bypassToken: String!) {
    getBypassTokenStatus(targetAccountId: $targetAccountId, bypassToken: $bypassToken) {
      exists
      isRevoked
      isExpired
      expiresAt
    }
  }
`;

export const USE_ADMIN_OTP_BYPASS = gql`
  mutation UseAdminOtpBypass($bypassToken: String!) {
    useAdminOtpBypass(bypassToken: $bypassToken) {
      success
    }
  }
`;
export const REGENERATE_ADMIN_BACKUP_CODES = gql`
  mutation RegenerateAdminBackupCodes {
    regenerateAdminBackupCodes {
      backupCodes
    }
  }
`;

export const GET_ACTIVE_BYPASS_TOKEN = gql`
  query GetActiveBypassToken($targetAccountId: String!) {
    getActiveBypassToken(targetAccountId: $targetAccountId) {
      bypassToken
      maskedToken
      expiresAt
      isRevoked
      isExpired
    }
  }
`;

export const RESET_ADMIN_OTP = gql`
  mutation ResetAdminOtp($targetAccountId: String!) {
    resetAdminOtp(targetAccountId: $targetAccountId) {
      success
    }
  }
`;